export function isLessonPath(path) {
  return new RegExp('/courses/[\\w-]+/lessons/[\\w-]+').test(path)
}
